import { gql } from '@apollo/client'

const DISH_CURATION_DATES_BY_CURATOR_QUERY = gql`
  query dishCurationDatesByCurator($menuId: ID!, $curatorIds: [ID!]!) {
    dishCurationDatesByCurator(menuId: $menuId, curatorIds: $curatorIds) {
      userId
      curatedAt
    }
  }
`

export default DISH_CURATION_DATES_BY_CURATOR_QUERY
